import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProgressActivity = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgProgressActivity" data-sentry-source-file="ProgressActivity.tsx">
            <mask id='progress_activity_svg__a' width={24} height={24} x={0} y={0} maskUnits='userSpaceOnUse' style={{
      maskType: 'alpha'
    }} data-sentry-element="mask" data-sentry-source-file="ProgressActivity.tsx">
                <path fill='#D9D9D9' d='M0 0h24v24H0z' data-sentry-element="path" data-sentry-source-file="ProgressActivity.tsx" />
            </mask>
            <g mask='url(#progress_activity_svg__a)' data-sentry-element="g" data-sentry-source-file="ProgressActivity.tsx">
                <path fill='currentColor' d='M12 2.751c0-.415-.337-.754-.75-.723a10 10 0 1 0 10.722 10.723c.03-.414-.308-.751-.723-.751s-.748.337-.785.75a8.496 8.496 0 1 1-9.214-9.214c.413-.037.75-.37.75-.785' data-sentry-element="path" data-sentry-source-file="ProgressActivity.tsx" />
            </g>
        </svg>;
};
export default SvgProgressActivity;